export default __webpack_public_path__ + "static/media/empty.f46c70e6.png";